import { Close } from "@mui/icons-material";
import {
	Alert,
	AppBar,
	Button,
	Dialog,
	IconButton,
	Slide,
	Toolbar,
	Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteAllOptionImgs } from "../redux/actions/pollOptions.action";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const Form = ({
	isEdit,
	openForm,
	setOpenForm,
	title,
	children,
	setDetails,
	handleSubmit,
	setEditDetails,
}) => {
	const dispatch = useDispatch();
	const {pollOptions} = useSelector((state) => {
		return {
            pollOptions: state.pollOptionsReducer.pollOptions
        };
	});

	const handleCloseForm = () => {
		let links = [];
		try {
			for(let key in pollOptions){
				links.push(pollOptions[key]?.data)
			}
			if(!isEdit){
				dispatch(deleteAllOptionImgs({links}));
			}			
		} catch (error) {
		}
		setOpenForm(false);
		setDetails({});
		setEditDetails({});
	};

	return (
		<Dialog
			fullScreen
			open={openForm}
			onClose={handleCloseForm}
			TransitionComponent={Transition}>
			<AppBar sx={{ position: "relative" }}>
				<Toolbar>
					<IconButton
						edge='start'
						color='inherit'
						onClick={handleCloseForm}
						aria-label='close'>
						<Close />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
						{title}
					</Typography>
					<Button autoFocus color='inherit' onClick={(e) => handleSubmit(e)}>
						save
					</Button>
				</Toolbar>
			</AppBar>
			{children}
		</Dialog>
	);
};

export default Form;
